/** Shared sticky / fixed page header bar — title 24px Lato, subtitle 16px Lato, 16px vertical padding. */

export const STICKY_PAGE_HEADER_SX = {
  flexShrink: 0,
  boxSizing: "border-box",
  width: "100%",
  px: { xs: 2, md: 3 },
  py: "16px",
  bgcolor: "#FFFFFF",
  borderBottom: "1px solid #E6E6E6",
};

export const STICKY_PAGE_HEADER_OUTER_ROW_SX = {
  display: "flex",
  alignItems: "flex-start",
  gap: "5px",
  width: "100%",
  minWidth: 0,
};

export const STICKY_PAGE_HEADER_TEXT_COLUMN_SX = {
  flex: "1 1 auto",
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

export const PAGE_HEADER_TITLE_SX = {
  fontFamily: "Lato, sans-serif",
  fontSize: { xs: 20, sm: 24 },
  fontWeight: 700,
  lineHeight: { xs: "28px", sm: "100%" },
  letterSpacing: "-0.5px",
  color: "#000000",
  m: 0,
  maxWidth: "100%",
  whiteSpace: "normal",
  overflowWrap: { xs: "break-word", md: "normal" },
  wordBreak: { xs: "break-word", md: "normal" },
};

export const PAGE_HEADER_SUBTITLE_SX = {
  fontFamily: "Lato, sans-serif",
  fontSize: { xs: 14, sm: 16 },
  fontWeight: 500,
  lineHeight: { xs: "21px", sm: "24px" },
  letterSpacing: 0,
  color: "#383838",
  m: 0,
  maxWidth: "100%",
  whiteSpace: "normal",
  overflowWrap: { xs: "break-word", md: "normal" },
  wordBreak: { xs: "break-word", md: "normal" },
};

export const STICKY_PAGE_HEADER_SUBTITLE_SX = {
  ...PAGE_HEADER_SUBTITLE_SX,
};
